import '../../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import '../../../../../node_modules/lit-html/lit-html.js';
import '../../../../../node_modules/lit-element/lit-element.js';
import { css as i } from '../../../../../node_modules/lit-element/node_modules/@lit/reactive-element/css-tag.js';

var css_248z = i`.card-text{-webkit-line-clamp:3;font-size:18px;font-weight:400;line-height:24px;margin:4px 0 0}.card-text,.card-text.no-image{-webkit-box-orient:vertical;display:box;overflow:hidden}.card-text.no-image{-webkit-line-clamp:4}@media (max-width:1365px){.card-text.no-image{height:0;margin:0;padding:0;visibility:hidden}}@media (min-width:768px){.card-text{margin:8px 0 0}}`;

export { css_248z as default };
